<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--subheader">
            <td style="width: 33%">
              <span>{{ 'plugins.interventiontasks.client' | translate }}</span>
            </td>
            <td style="width: 33%">
              <span>{{ 'plugins.interventiontasks.description' | translate }}</span>
            </td>
            <td style="width: 33%">
              <span>{{ 'plugins.interventiontasks.date' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" formArrayName="tasks" *ngFor="let item of formData.controls; let i = index">
            <td style="width: 33%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input type="text" formControlName="Client" class="ir-form-set" />
              </div>
            </td>
            <td style="width: 33%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input type="text" formControlName="Description" class="ir-form-set" />
              </div>
            </td>
            <td style="width: 33%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input type="date" formControlName="Date" class="ir-form-set" />
              </div>
            </td>
            <td class="th-plugin-line--remove">
              <i class="material-icons" (click)="remove(i)">remove_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td colspan="3">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
